import type {
  ActivePoliciesListResponse,
  OptionsListResponse,
  PaymentOptionsResponse,
  RenewQuoteResponse,
} from './RenewService.types';

import { fromUnixSecondsToDate, timestampToDate } from '@/shared/utils/date';

export function serializeRenewQuote(data: RenewQuoteResponse) {
  return {
    quoteNumber: data.quoteno,
    productBonus: data.productBonus,
    promotionType: data.promotionType,
    details: {
      mobileNumber: data.details.mobileNo,
      policyNumber: data.details.policyNumber,
      qatarID: data.details.civilId,
      brandCode: data.details.brandCode,
      brandName: data.details.brandName,
      email: data.details.email,
      chassisNumber: data.details.chassisNo,
      modelCode: data.details.modelCode,
      modelName: data.details.modelName,
      modelYear: data.details.modelYear,
      plateNumber: data.details.plateNumber,
      oldPolicyEndDate: fromUnixSecondsToDate(Number(data.details.oldPolEndDate)),
      policyFromDate: timestampToDate(data.details.policyFromDate),
      insuredName: data.details.insuredName,
      renewSchCode: data.details.renewSchCode,
      noClaimsDiscount: data.details.noClaimsDiscount,
      idsOfEnabledAddons: data.details.oldCoversList,
      vehicleUsage: data.details.vehicleUsage,
      vehicleType: data.details.vehicleType,
      vehicleTypeName: data.details.vehicleTypeName,
      transId: data.details.transId,
      plateTypeName: data.details.plateCharacterCode,
      plateType: data.details.plateCharacter,
      vehicleShapeName: data.details.vehicleShapeName,
      vehicleShapeCode: data.details.vehicleShape,
      renewDeductibleValue: data.details.renewDeductibleValue,
      oldProdCode: data.details.oldProdCode,
      driverDob: data.details.driverDob ? timestampToDate(data.details.driverDob) : null,
    },
    schemes: data.schemes
      .map((scheme, index) => ({
        schemeCode: scheme.glmScheme ? `${scheme.schemecode}-${index}` : scheme.schemecode,
        price: scheme.price,
        monthlyPrice: scheme.monthlyPrice,
        deductible: scheme.deductible,
        discounts: scheme.discounts.sort((a, b) => Number(b.price) - Number(a.price)),
        discount: scheme.discount,
        covers: scheme.included,
        addons: scheme.ids,
        glmScheme: scheme.glmScheme,
        deductibleCode: scheme.deductibleCode,
        productcode: scheme.productcode,
      }))
      .sort((a, b) => a.price - b.price),
  };
}

export function serializeActivePoliciesList(data: ActivePoliciesListResponse[]) {
  const firstPolicy = data[0];

  return {
    policyStatus: firstPolicy.policyStatus,
    policyStartDate: timestampToDate(firstPolicy.policyStartDate),
    policyEndDate: timestampToDate(firstPolicy.policyEndDate),
    makeModel: firstPolicy.makeModel,
    modelYear: firstPolicy.modelYear,
    prodCode: firstPolicy.prodCode,
    plateNumber: firstPolicy.plateNumber,
    policyNumber: firstPolicy.policyNumber,
  };
}

export function serializePaymentOptions(data: Record<number, PaymentOptionsResponse>) {
  const paymentOptions = Object.entries(data).map(([_, value]) => ({
    name: value.paymDesc,
    type: value.paymtType,
    disclaimer: value.paymCond,
  }));

  return paymentOptions;
}

export function serializeOptionsList(data: Record<number, OptionsListResponse>) {
  return Object.entries(data).map(([_, value]) => ({
    value: value.code,
    title: value.desc,
  }));
}
